import React from 'react';
import Reveal from './Reveal';

const GAMES = [
  { name: 'Mémoire vive', kind: 'Rappel', time: '8–12 min' },
  { name: 'Attention soutenue', kind: 'Focus', time: '6–10 min' },
  { name: 'Associations', kind: 'Flexibilité', time: '8 min' },
  { name: 'Labyrinthe logique', kind: 'Raisonnement', time: '10–15 min' },
  { name: 'Rythme visuel', kind: 'Vitesse', time: '5 min' },
  { name: 'Respiration guidée', kind: 'Calme', time: '7 min' },
  { name: 'Scan corporel', kind: 'Présence', time: '10 min' },
  { name: 'Cercle du jour', kind: 'Communauté', time: 'Libre' },
];

export default function Atelier() {
  return (
    <section id="atelier" className="py-20 lg:py-28 bg-sand/40">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-copper-600">
              L’atelier
            </p>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-tight">
              Plus de 50 jeux, un même fil conducteur.
            </h2>
            <p className="mt-5 text-clay text-lg leading-relaxed">
              Chaque activité est courte, claire et conçue pour s’intégrer à une
              journée réelle — du défi cognitif à la séance de pleine conscience.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {GAMES.map((game, i) => (
            <Reveal key={game.name} delay={i * 50}>
              <article className="rounded-xl border border-sand bg-paper p-5 h-full">
                <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-clay">
                  {game.kind}
                </p>
                <h3 className="mt-3 font-display text-xl font-semibold">{game.name}</h3>
                <p className="mt-6 text-sm text-clay">{game.time}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-8 rounded-2xl bg-paper border border-sand p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
            <p className="text-clay max-w-xl leading-relaxed">
              L’accès au catalogue complet — jeux, séances guidées et espace
              communautaire — est ouvert en illimité pendant 3 mois.
            </p>
            <a
              href="/s"
              className="shrink-0 inline-flex justify-center px-6 py-3 rounded-md bg-copper-500 text-paper font-bold hover:bg-copper-400 transition-colors"
            >
              Accéder à l’atelier
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
